export default {
  fonts: {
    body: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    heading: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
} as const
